module.exports = __webpack_public_path__ + "static/media/delivery2.a1e16f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Delivery/images/delivery2.jpg
// module id = 325
// module chunks = 0